// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SmartTextareaInput":"bgb_a bhn_ve bhn_vr bhn_xh bhn_vj"};